export const loginFormForCheckUser = (response) => (
    response?.loginMethod === "otp" ? "OTP" : "PASSWORD"
);

export const isAccountSetupFormValid = (form, passwordRequired) => (
    String(form?.firstname || "").trim().length >= 2
    && String(form?.lastname || "").trim().length >= 2
    && String(form?.fullname || "").trim().length >= 2
    && Boolean(form?.gender)
    && (!passwordRequired || (
        String(form?.password || "").length >= 6
        && form.password === form.passwordConfirmation
    ))
);

export const buildAccountSetupPayload = (form, passwordRequired) => ({
    firstname: String(form?.firstname || "").trim(),
    lastname: String(form?.lastname || "").trim(),
    fullname: String(form?.fullname || "").trim(),
    gender: form?.gender || null,
    ...(passwordRequired ? {
        password: form?.password || "",
        passwordConfirmation: form?.passwordConfirmation || "",
    } : {}),
});
